export default {
  getImpuestosListado(state) {
    var res = [];
    state.impuestosArray.forEach(e => {
      let aux = {
        id: e.id,
        nombre: e.nombre,
        cantidad: (e.impuesto * 100).toFixed(0) + ' %',
        impuesto: e.impuesto
      }
      res.push(aux);
    });
    return res;
  },
  getImpuestosSelect(state) {
    var res = [];
    state.impuestosArray.forEach(e => {
      let aux = {
        value: e.id,
        text: e.nombre + " | " + (e.impuesto * 100).toFixed(0) + ' %',
      }
      res.push(aux);
    });
    return res;
  }
}